var MediaStreamType;
(function (MediaStreamType) {
    MediaStreamType["MP4"] = "MP4";
    MediaStreamType["WEBM"] = "WEBM";
    MediaStreamType["HLS"] = "HLS";
    MediaStreamType["DASH"] = "DASH";
    MediaStreamType["OGG"] = "OGG";
    MediaStreamType["MOV"] = "MOV";
    MediaStreamType["MKV"] = "MKV";
})(MediaStreamType || (MediaStreamType = {}));
const MimeToStreamTypeMap = {
    'application/x-mpegURL': MediaStreamType.HLS,
    'application/vnd.apple.mpegURL': MediaStreamType.HLS,
    'application/dash+xml': MediaStreamType.DASH,
    'video/mp4': MediaStreamType.MP4,
    'video/x-mp4': MediaStreamType.MP4,
    'x-video/mp4': MediaStreamType.MP4,
    'video/webm': MediaStreamType.WEBM,
    'video/ogg': MediaStreamType.OGG,
    'video/quicktime': MediaStreamType.MOV,
    'video/x-matroska': MediaStreamType.MKV,
};
var MediaStreamDeliveryPriority;
(function (MediaStreamDeliveryPriority) {
    MediaStreamDeliveryPriority[MediaStreamDeliveryPriority["NATIVE_PROGRESSIVE"] = 0] = "NATIVE_PROGRESSIVE";
    MediaStreamDeliveryPriority[MediaStreamDeliveryPriority["ADAPTIVE_VIA_MSE"] = 1] = "ADAPTIVE_VIA_MSE";
    MediaStreamDeliveryPriority[MediaStreamDeliveryPriority["NATIVE_ADAPTIVE"] = 2] = "NATIVE_ADAPTIVE";
    MediaStreamDeliveryPriority[MediaStreamDeliveryPriority["FORCED"] = 3] = "FORCED";
})(MediaStreamDeliveryPriority || (MediaStreamDeliveryPriority = {}));
export { MediaStreamType, MimeToStreamTypeMap, MediaStreamDeliveryPriority };
//# sourceMappingURL=media-stream.js.map